/* Beessentials: small, dependency-free helpers */
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function reveal(root) {
    var els = (root || document).querySelectorAll('.bee-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }
  window.Bee = window.Bee || {};
  Bee.reveal = reveal;

  Bee.money = function (cents) {
    var r = (cents / 100);
    return 'R' + (r % 1 === 0 ? r.toFixed(0) : r.toFixed(2)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  };

  /* Real Shopify cart add, then open the theme cart drawer (or go to /cart) */
  Bee.addToCart = function (variantId, qty) {
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: variantId, quantity: qty }] };
    if (drawer && typeof drawer.renderContents === 'function') { body.sections = ['cart-drawer', 'cart-icon-bubble']; body.sections_url = location.pathname; }
    return fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok || j.status) { throw j; } return j; });
    }).then(function (j) {
      document.dispatchEvent(new CustomEvent('bee:added', { detail: { variantId: variantId, quantity: qty } }));
      if (body.sections && j.sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents({ id: variantId, sections: j.sections });
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
      return j;
    });
  };

  function header() {
    var root = document.documentElement;
    var m = document.getElementById('bee-nav-m');
    if (m) {
      m.addEventListener('toggle', function () { root.classList.toggle('bee-lock', m.open); });
      m.querySelectorAll('[data-bee-close], a').forEach(function (el) { el.addEventListener('click', function () { m.open = false; }); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && m.open) { m.open = false; m.querySelector('summary').focus(); } });
    }
    var hd = document.querySelector('.bee-hd');
    if (hd) {
      var on = false;
      window.addEventListener('scroll', function () {
        var s = window.scrollY > 8;
        if (s !== on) { on = s; hd.classList.toggle('is-scrolled', s); }
      }, { passive: true });
    }
  }
  function init() { reveal(); header(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { reveal(e.target); });
})();

/* Cart discount code box (snippets/bee-cart-discount.liquid) */
(function () {
  if (window.BeeDiscount) return;
  window.BeeDiscount = true;

  var TAG = '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true"><path d="M3.5 12.6V4.5a1 1 0 0 1 1-1h8.1a1 1 0 0 1 .7.3l7.4 7.4a1 1 0 0 1 0 1.4l-8.1 8.1a1 1 0 0 1-1.4 0l-7.4-7.4a1 1 0 0 1-.3-.7z" fill="none" stroke="currentColor" stroke-width="1.6"/><circle cx="8" cy="8" r="1.5" fill="currentColor"/></svg>';
  var X = '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; });
  }

  function paint(codes) {
    var html = (codes || []).map(function (d) {
      var c = esc(d.code);
      return '<li class="bee-disc__tag' + (d.applicable ? '' : ' is-off') + '">' + TAG +
        '<span class="bee-disc__code">' + c + '</span>' +
        (d.applicable ? '' : '<span class="bee-disc__note">not valid for this cart</span>') +
        '<button type="button" class="bee-disc__x" data-bee-disc-remove="' + c + '" aria-label="Remove discount ' + c + '">' + X + '</button></li>';
    }).join('');
    document.querySelectorAll('[data-bee-disc-tags]').forEach(function (ul) { ul.innerHTML = html; ul.setAttribute('data-painted', ''); });
  }

  function getCart() {
    return fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function refresh() {
    if (!document.querySelector('[data-bee-disc-tags]')) return;
    getCart().then(function (c) { paint(c.discount_codes); }).catch(function () {});
  }

  function onCartPage() {
    return /\/cart\/?$/.test(location.pathname);
  }

  function update(list) {
    var drawer = document.querySelector('cart-drawer');
    var body = { discount: list.join(',') };
    if (drawer && typeof drawer.renderContents === 'function' && !onCartPage()) {
      body.sections = ['cart-drawer', 'cart-icon-bubble'];
      body.sections_url = location.pathname;
    }
    var url = ((window.routes && window.routes.cart_update_url) || '/cart/update') + '.js';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; });
    });
  }

  function say(box, msg, isErr) {
    var m = box && box.querySelector('[data-bee-disc-msg]');
    if (m) { m.textContent = msg; m.className = 'bee-disc__msg ' + (isErr ? 'is-err' : 'is-ok'); }
  }

  function finish(j, msg, isErr) {
    var drawer = document.querySelector('cart-drawer');
    if (j.sections && drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents({ id: null, sections: j.sections });
      setTimeout(function () {
        paint(j.discount_codes);
        say(drawer.querySelector('[data-bee-disc]'), msg, isErr);
        var dt = drawer.querySelector('[data-bee-disc-toggle]');
        if (dt && isErr) dt.open = true;
      }, 30);
      document.dispatchEvent(new CustomEvent('bee:discount', { detail: { cart: j } }));
    } else {
      try { if (msg) sessionStorage.setItem('beeDiscMsg', JSON.stringify([msg, !!isErr])); } catch (e) {}
      location.reload();
    }
  }

  function same(a, b) { return a.toLowerCase() === b.toLowerCase(); }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-bee-disc-form]');
    if (!form) return;
    e.preventDefault();
    var box = form.closest('[data-bee-disc]');
    var input = form.querySelector('input');
    var code = (input.value || '').trim();
    if (!code) { say(box, 'Please enter a discount code.', true); input.focus(); return; }
    box.classList.add('is-busy');
    getCart().then(function (c) {
      var list = (c.discount_codes || []).map(function (d) { return d.code; });
      if (list.some(function (x) { return same(x, code); })) {
        box.classList.remove('is-busy');
        say(box, 'That code is already applied.', true);
        return;
      }
      list.push(code);
      return update(list).then(function (j) {
        var hit = (j.discount_codes || []).filter(function (d) { return same(d.code, code); })[0];
        if (hit && hit.applicable) return finish(j, 'Code ' + hit.code.toUpperCase() + ' applied.', false);
        /* Not valid for this cart: take it off again so it doesn't sit on the order */
        var keep = (j.discount_codes || []).filter(function (d) { return !same(d.code, code); }).map(function (d) { return d.code; });
        return update(keep).then(function (j2) {
          finish(j2, 'Sorry, ' + code.toUpperCase() + " isn't valid for this cart.", true);
        });
      });
    }).catch(function () {
      box.classList.remove('is-busy');
      say(box, 'Something went wrong. Please try again.', true);
    });
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-bee-disc-remove]');
    if (!btn) return;
    var code = btn.getAttribute('data-bee-disc-remove');
    var box = btn.closest('[data-bee-disc]');
    if (box) box.classList.add('is-busy');
    getCart().then(function (c) {
      var list = (c.discount_codes || []).map(function (d) { return d.code; }).filter(function (x) { return !same(x, code); });
      return update(list).then(function (j) { finish(j, 'Code removed.', false); });
    }).catch(function () {
      if (box) box.classList.remove('is-busy');
      say(box, 'Something went wrong. Please try again.', true);
    });
  });

  /* Repaint the tags whenever the theme redraws the cart (quantity changes, add to cart, etc.) */
  var t;
  function watch() {
    new MutationObserver(function () {
      if (document.querySelector('[data-bee-disc-tags]:not([data-painted])')) { clearTimeout(t); t = setTimeout(refresh, 60); }
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    refresh();
    watch();
    try {
      var saved = sessionStorage.getItem('beeDiscMsg');
      if (saved) {
        sessionStorage.removeItem('beeDiscMsg');
        saved = JSON.parse(saved);
        say(document.querySelector('main [data-bee-disc]') || document.querySelector('[data-bee-disc]'), saved[0], saved[1]);
      }
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* Beessentials: cart upsell (Wrap Storage Pouch). Adds the real pouch variant only when the customer taps the button.
   Cart drawer: Bee.addToCart redraws the drawer. Cart page: redraws with the theme's own cart sections. No redirects. */
(function () {
  var busy = false;
  function failMsg(btn, err) {
    var box = btn.closest('[data-bee-upsell]');
    var msg = box && box.querySelector('[data-bee-upsell-msg]');
    if (msg) msg.textContent = (err && (err.description || err.message)) || 'Sorry, something went wrong. Please try again.';
  }
  function addOnPage(page, id) {
    var map = page.getSectionsToRender();
    return fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: map.map(function (s) { return s.section; }), sections_url: location.pathname })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok || j.status) { throw j; } return j; });
    }).then(function (j) {
      map.forEach(function (s) {
        var el = document.getElementById(s.id);
        if (!el || !j.sections || j.sections[s.section] == null) return;
        var target = el.querySelector(s.selector) || el;
        target.innerHTML = page.getSectionInnerHTML(j.sections[s.section], s.selector);
      });
      document.dispatchEvent(new CustomEvent('bee:added', { detail: { variantId: id, quantity: 1 } }));
      return fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js').then(function (r) { return r.json(); }).then(function (c) {
        if (typeof page.updateProgressBar === 'function') page.updateProgressBar({ total_price: c.total_price, items_subtotal_price: c.items_subtotal_price });
      }).catch(function () {});
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-bee-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    if (busy || btn.disabled) return;
    var id = parseInt(btn.getAttribute('data-bee-upsell-add'), 10);
    if (!id) return;
    busy = true;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    var page = !btn.closest('cart-drawer') && document.querySelector('cart-items');
    var run = page && typeof page.getSectionsToRender === 'function' ? addOnPage(page, id) : Bee.addToCart(id, 1);
    run.then(function () { busy = false; }, function (err) {
      busy = false;
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      failMsg(btn, err);
    });
  });
})();
